import axios from "axios"

export default function updateLoyaltyPointStatus({
    id,
    status }) {
    return new Promise((resolve, reject) => {
        axios.post(`/campaign/api/admin/campaigns/${id}/status`,
            {
                status
            })
            .then(response => resolve(response.data))
            .catch(error => reject(error.response.data))
    })
}